/* eslint-disable */
import React, { useEffect, useState, useContext } from 'react';
import MagnifyingGlass from '../../../Assets/images/svg/dar_magnifying.svg';
import SettingsDropdown from '../../../Assets/images/svg/dar_selected_master.svg';
import DropArrow from '../../../Assets/images/svg/dar_drop_down_arrow.svg';
import ListImage from '../../../Assets/images/svg/dar_list.svg';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import styles from './tableView.module.scss';
import Checkbox from '@mui/material/Checkbox';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DataGridComponent from '../../../Components/DataGrid/dataGrid';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { SKILL_CERT_PROFILE,ASSIGN_TEXT } from '../../../Constants/strings';
import { useNavigate } from 'react-router-dom';
import { columnCustomizationList, parameterList, tabularViewList, assignDealToEmployee } from '../../../Api/request/dealDashboard';
import UseAxios from '../../../Api/http/http';
import { AuthContext } from '../../../Contexts/AuthContext';
import { STATUS_CODES } from '../../../Api/resources/statusCodes';
import ManualAssignmentForm from './manualAssignmentModal';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { MODULE_NAMES } from '../../../Constants/modules';


const TableView = () => {
  const { userProfile } = useContext(AuthContext);
  const userId = userProfile?.id;
  const [customizedColumns, setCustomizedColumns] = useState([]);
  const [customParameters, setCustomParameters] = useState([]);
  const [tablePageNumber, setTablePageNumber] = useState(1);
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [tableNames, setTableNames] = useState([]);
  const [isMobileView, setIsMobileView] = useState(false);
  const [openSelects, setOpenSelects] = useState({});
  const [tablePageSize, setTablePageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [sortField, setSortField] = useState(''); 
  const [sortOrder, setSortOrder] = useState('');
  const [searchText, setSearchText] = useState('');
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { snackbarOpen } = useSnackbar();

  //deal manual assignment permission access
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.DEAL_TRANSITION_DEAL_ASSIGN] || []
    : [];

const hasAccess = (action) => permission.includes(action);

    //deal dashboard permission access
  const dashboardPermission = userProfile?.permissions
  ? userProfile.permissions[MODULE_NAMES.DEAL_TRANSITION_DASHBOARD] || []
  : [];

  const hasAccessDashboard = (action) => dashboardPermission.includes(action);

  const navigate = useNavigate();
  const ITEM_HEIGHT = 100;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: '400px',
      },
    },
  };
  const fetchCustomParameters = () => {
    UseAxios(parameterList(userId))
      .then((response) => {
        const customParameters = response.data.custom_parameters;
        const allParameters = response.data.deal_parameters;
        const updatedColumns = allParameters.map((param) => ({
          name: param.parameter_name,
          checked: customParameters.includes(param.parameter_id),
          id: param.parameter_id,
        }));
        setCustomizedColumns(updatedColumns);
        setTableNames(updatedColumns);
        setCustomParameters(customParameters);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const updateColumnCustomizationList = async (userId, customParameters) => {
    try {
      await UseAxios(columnCustomizationList(userId, customParameters));
    } catch (error) {
      setCustomizedColumns([]);
    }
  };

  useEffect(() =>{
  },[customParameters])

  useEffect(() => {
    UseAxios(tabularViewList(userId, tablePageNumber, 10, searchText, sortField, sortOrder))
      .then((response) => {
        if (response.status === STATUS_CODES.NO_DATA) {
          setRows([]);
          setTotalRecords(0);
          setTablePageSize(1);
        } else if (response?.data) {
          setRows(response.data.data || []);
          setTablePageSize(response.data.totalPages || 1);
          setTotalRecords(response.data.totalDeals || 0);
         
        } else {
          setTablePageSize(1);
          setRows([]);
          setTotalRecords(0);
          
        }
      })
      .catch((error) => {
        console.error(error);
        setTotalRecords(0);
        setRows([]);
       setTablePageSize(1);
      });
  }, [tablePageNumber, searchText, sortField, sortOrder]);
  
  

  useEffect(() => {
    checkMobileView();
    fetchCustomParameters();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const navigateOnView = (params) => {
    const selectedId = params.row.id; 
    const dealStatus = params.row.deal_status;  
  
    if (dealStatus === 'Transition Pending') {
      navigate('/deal-transition/dashboard/transition-form?id=' + selectedId);
    } else {
      navigate('/deal-transition/dashboard/details-view?id=' + selectedId);
    }
  };

  const handleSearch = (event) => {
    const searchQuery = event.target.value.toLowerCase();
    setSearchText(searchQuery);
    setTablePageNumber(1); 
  };

  const handleSortChange = (sortModel) => {
    if (sortModel.length > 0) {
      const { field } = sortModel[0];
  
      setSortField((prevSortField) => {
        if (prevSortField === field) {
          setSortOrder((prevSortOrder) => {
            if (prevSortOrder === 'asc') {
              return 'desc';
            } else if (prevSortOrder === 'desc') {
              return '';
            } else {
              return 'asc';
            }
          });
        } else {
          setSortOrder('asc');
        }
        return field;
      });
    } else {
      setSortField('');
      setSortOrder('');
    }
  };
  

  const formatFieldName = (name) => {
    const formattedName = name.toLowerCase().replace(/\s+/g, '_');
    if (!formattedName.startsWith('deal_')) { // Check if 'deal_' is included at the start
      return `deal_${formattedName}`;
    } else {
      return formattedName;
    }
  };
  

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setTableNames(typeof value === 'string' ? value.split(',') : value);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedColumns = Array.from(customizedColumns); // Create a copy of the current customizedColumns array
    const [removed] = reorderedColumns.splice(result.source.index, 1); // Reorder the items in the array
    reorderedColumns.splice(result.destination.index, 0, removed);
    setCustomizedColumns(reorderedColumns); // Update both customizedColumns and tableNames based on the new order
    const updatedTableNames = reorderedColumns.filter((col) => col.checked); // Now update tableNames to maintain the checked/unchecked state
    setTableNames(updatedTableNames);
  };

  const filteredRows = rows;

  const handleSelectOpen = (id) => {
    setOpenSelects((prevState) => ({
      ...prevState,
      [id]: true, // Set the specific select to open
    }));
  };

  const handleSelectClose = (id) => {
    setOpenSelects((prevState) => ({
      ...prevState,
      [id]: false, // Set the specific select to close
    }));
  };

  const handleAssignClick = (rowData) => {
    setSelectedRow(rowData);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const getColor = (dealStatus, type) => {
    const statusColors = {
      pending: ['#FFF4EA', '#FF8934'],
      in_progress: ['#FFF4EA', '#FF8934'],
      awaiting_commercials: ['#FFF4EA', '#FF8934'],
      closed: ['#FDEFEF', '#FF2E2E'],
      discovery: ['#ECF7FF', '#41B1FF'],
      under_review: ['#FFF8E4', '#FFB800'],
      awaiting_legal: ['#F5FBEF', '#6EDD00'],
      awaiting_approval: ['#FFEBFF', '#FB3DFF'],
      under_negotiation: ['#EFF9F6', '#00D7A3'],
      solution: ['#EDECF8', '#6B5CE8']
    };
  
    for (const key in statusColors) {
      if (dealStatus.includes(key)) {
        return type === 'background' ? statusColors[key][0] : statusColors[key][1];
      }
    }
  
    return type === 'background' ? '#F5FBEF' : '#6EDD00';
  }; 


  const formatDate = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } else {
      return '';
    }
  };

  const displayKeyboardArrowDownIcon = (fontColor, openSelects,id) => {
    return (
      <KeyboardArrowDownIcon
        sx={{
          display: 'none',
          color: fontColor,
          fontSize: 20,
          transition: 'transform 0.3s',
          transform: openSelects[id]
            ? 'rotate(180deg)'
            : 'rotate(0deg)',
        }}
      />
    )
  }

  const displayImageIcon=(DropArrow, open)=>{
    return(
      <img
      src={DropArrow}
      alt="DropArrow Icon"
      className={styles['tableView-headerSection-dropArrow']}
      style={{
        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
      }}
    />
    )
  }
  const columns = tableNames
    .filter(({ checked }) => checked)
    .map(({ name }) => ({
      field: formatFieldName(name),
      headerName: name,
      width: 150,
      flex: !isMobileView ? 0.1 : undefined,
      sortable: false,
      disableColumnMenu: true,
      hideCoumnMenuIcon: true,
      renderCell: (params) => {
        const backgroundColor = getColor(params.row.deal_status, 'background');
        const fontColor = getColor(params.row.deal_status, 'font'); 
        const today = new Date();
        const dealDueDate = new Date(params.row.deal_due_date);
        const timeDifference = dealDueDate.getTime() - today.getTime();
        const daysDifference = timeDifference / (1000 * 3600 * 24); 
        let dealNameColor = 'transparent';
        if (params.row.deal_pending_with === '') {
          dealNameColor = '#FFD465'; // Yellow
        } else if (daysDifference <= 3 && daysDifference >= 0) {
          dealNameColor = '#FFB7BF'; // pink
        } else if (daysDifference < 0) {
          dealNameColor = '#E30425'; // Red
        }
        switch (name) {
          case 'Status': {
            return (
              <Select
                key={params.id}
                sx={{
                  padding: '0px !important',
                  fontSize: 14,
                  height: 30,
                  borderRadius: 2,
                  backgroundColor: backgroundColor,
                  textAlign: 'start',
                  color: fontColor,
                  border: 'none',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                    padding: 0,
                  },
                  '& .MuiSelect-select': { padding: '5px !important' },
                }}
                IconComponent={() => displayKeyboardArrowDownIcon(fontColor, openSelects,params.id)}
                onOpen={() => handleSelectOpen(params.id)}
                onClose={() => handleSelectClose(params.id)}
                value={params.value}
                input={<OutlinedInput label="Tag" />}
                renderValue={(value) => value}
                onChange={(event) =>
                  handleStatusChange(params.id, event.target.value)
                }
              >
                <MenuItem key={params.value} value={params.value}>
                {params.value}
                </MenuItem>
              </Select>
            );
          }
          case 'Deal Name':
            return (
              <div key={params.id} className={styles['tableView-cellDesign-dealName']}>
                {dealNameColor !==''  ? (
                  <div className={styles['tableView-cellDesign-dealName-dot']} style={{backgroundColor: dealNameColor}}></div>
                ):null}
                <div>{params.value}</div>
              </div>
            );

            case 'Pending with': {
              const pendingWith =
                params.row.deal_pending_with?.trim() === 'black'
                  ? 'NA'
                  : params.row.deal_pending_with?.trim();
              return (
                <div
                  className={styles['pending-with-container']}
                  onMouseEnter={() => setHoveredRowId(params.row.id)}
                  onMouseLeave={() => setHoveredRowId(null)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      setHoveredRowId(params.row.id);
                    }
                  }}
                >
                  <span>{pendingWith || 'NA'}</span>
                  {hoveredRowId === params.row.id && hasAccess('update') && (
                    <button
                      onClick={() => handleAssignClick(params.row)}
                      disabled={!hasAccess('update')}
                      className={styles['pending-with-assign-button']}
                      style={{
                        cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
                        opacity: !hasAccess('update') ? 0.5 : 1,
                      }}
                    >
                      {ASSIGN_TEXT}
                    </button>
                  )}
                </div>
              );
            } 
          default:
          if (params.field.toLowerCase().includes("date")) {
            return formatDate(params.value);
          } else {
            return params.value;
          }          
        }
      },
    }));
  
  const sortFilterColumns = columns.map((column) => {
    return column.field.startsWith('deal_') ? column.field : `deal_${column.field}`;
  });
  
  const handleStatusChange = (id, value) => {
    console.log(`Row ID: ${id}, New Status: ${value}`); // Handle the status change logic here
  };

  const dueDateIndication = {
    field: 'dueDateIndications',
    headerName: '',
    width: 50,
    renderCell: (params) => {
      let bulletClass = null;
  
      if (params.row.isDealClosedDateNear) {
        bulletClass = styles['tableView-bulletPoints3'];
      } else if (params.row.isCloseDateCrossed) {
        bulletClass = styles['tableView-bulletPoints2'];
      } else if (params.row.isDealAssigned === false) {
        bulletClass = styles['tableView-bulletPoints1'];
      }
  
      return (
        <div
          key={params.id}
          className={styles['dueDateIndications-container']}
        >
          {bulletClass && <div className={bulletClass}></div>}
        </div>
      );
    },
    sortable: false,
    disableColumnMenu: true,
  };
  


  const desktopColumns = [
    dueDateIndication,
    ...columns,
    {
      headerName: 'Actions',
      type: 'number',
      headerClassName: !isMobileView ? '' : `${styles['action-column']} ${styles['tableView-action-cellWidth']}`,
      cellClassName: !isMobileView ? `${styles['tableView-action-cell']}` : `${styles['action-cell']} ${styles['tableView-action-cellWidth']}`,
      flex: 0.07,
      minWidth: 140,
      renderCell: (params) => {
        const { deal_status } = params.row;
        const buttonText = deal_status === 'Transition Pending' 
          ? SKILL_CERT_PROFILE.FILL_TRANSITION 
          : SKILL_CERT_PROFILE.VIEW;
    
        return (
          <button
            onClick={() => { navigateOnView(params) }}
            className={styles['tableView-actions-viewButton']}
            disabled={!hasAccessDashboard('update') && buttonText===SKILL_CERT_PROFILE.FILL_TRANSITION}
          >
            {buttonText}
          </button>
        );
      },
      sortable: false,
      disableColumnMenu: true,
      hideCoumnMenuIcon: true,
    }
  ];

  const handleAssign = async (employee) => {
    if (!employee || !selectedRow) return;
    const dealId = selectedRow.id;
    const employeeId = employee.employeeId;
    const assigneeName = employee.name;
    try {
      const response = await UseAxios(assignDealToEmployee(dealId, employeeId, assigneeName));
      if (response.data.status === 200) {
        setRows((prevRows) => {
          const updatedRows = prevRows.map((row) =>
            row.id === dealId
              ? { ...row, deal_pending_with: employee.name }
              : row
          );

          return updatedRows;
        });
        snackbarOpen('Deal assigned successfully', 'success');
        setModalOpen(false);
      } else {
        snackbarOpen('Failed to assign deal', 'error');
      }
    } catch (error) {
      snackbarOpen('Error assigning deal', 'error');
      console.error(error);
    }
  };
  
 

  return (
    <div className="users-manage-outer-layer">
      <div className="users-manage">
        <div
          className={`${styles['tableView-search-and-buttons']} ${styles['tableView-headerSection-flex']} ${styles['filteredRows-tableView']} ${styles['tableView-margin']}`}
          style={{ padding: '8px 12px' }}
        >
          <div className={styles['tableView-headerSection-main']}>
            <div className={`${styles['tableView-search']} ${styles['tableView-headerSection-mainSearchInput']}`}>
              <div className={styles['tableView-headerSection-search']}>
                <img src={MagnifyingGlass} alt="Search" />
                <input
                  id="tableView-search-input"
                  type="text"
                  placeholder="Search..."
                  onChange={handleSearch}
                  className={styles['tableView-headerSection-searchInput']}
                />
              </div>
            </div>
            <div
              className={styles['tableView-headerSection-selectMain']}
              style={{ alignSelf: !isMobileView ? 'center' : 'end' }}
            >
              <img
                src={SettingsDropdown}
                alt="Search"
                className={styles['tableView-headerSection-settingsIcon']}
              />
              <FormControl
                sx={{
                  m: !isMobileView ? 1 : 0,
                  width: 150,
                  ml: !isMobileView ? 1 : 0.5,
                }}
              >
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  value={customizedColumns}
                  onChange={handleChange}
                  input={<OutlinedInput label="Tag" />}
                  renderValue={() => 'Customize columns'}
                  MenuProps={MenuProps}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  IconComponent={()=> displayImageIcon(DropArrow, open)}
                  sx={{
                    fontSize: 14,
                    fontWeight: !isMobileView ? '400' : '600',
                    padding: '0px !important',
                    textAlign: 'start',
                    color: '#6B5CE8',
                    border: 'none',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                      padding: 0,
                    },
                    '& .MuiSelect-select': { padding: '0px !important' },
                  }}
                >
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="tableNames">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {customizedColumns.map(({ name }, index) => (
                            <Draggable
                              key={name}
                              draggableId={name}
                              index={index}
                            >
                              {(provided) => (
                                <MenuItem
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  key={name}
                                  value={name}
                                  onClick={(e) => e.stopPropagation()} //NOSONAR
                                >
                                  <img src={ListImage} alt="list" />
                                  <Checkbox
                                    checked={tableNames.some(
                                      (item) => //NOSONAR
                                        item.name === name &&
                                        item.checked === true
                                    )}
                                    onClick={(e) => { //NOSONAR
                                      e.stopPropagation();
                                    }} // Prevent propagation to the MenuItem click
                                    onChange={() => { //NOSONAR
                                      setCustomizedColumns(
                                        (
                                          prevColumns // Toggle checkbox state in both customizedColumns and tableNames
                                        ) =>
                                          prevColumns.map((item) =>
                                            item.name === name
                                              ? {
                                                ...item,
                                                checked: !item.checked,
                                              }
                                              : item
                                          )
                                      );
                                      setTableNames((prevNames) => {
                                        const existing = prevNames.find(
                                          (item) => item.name === name
                                        );
                                        if (existing) {
                                          // If item already exists, toggle the `checked` state
                                          return prevNames.map((item) =>
                                            item.name === name
                                              ? {
                                                ...item,
                                                checked: !item.checked,
                                              }
                                              : item
                                          );
                                        } else {
                                          // If item doesn't exist, add it with `checked: true`
                                          return [
                                            ...prevNames,
                                            { name, checked: true },
                                          ];
                                        }
                                      });
                                      setCustomParameters((prevParameters) => {
                                        const clickedParam = customizedColumns.find(
                                          (item) => item.name === name
                                        );

                                        if (!clickedParam) return prevParameters;

                                        const updatedParameters = clickedParam.checked
                                          ? prevParameters.filter((id) => id !== clickedParam.id)
                                          : [...prevParameters, clickedParam.id];

                                        updateColumnCustomizationList(userId, updatedParameters);

                                        return updatedParameters;
                                      });
                                    }}
                                    sx={{
                                      '&.Mui-checked': { color: '#5D3FD3' },
                                    }}
                                  />
                                  <ListItemText
                                    primary={name}
                                    primaryTypographyProps={{
                                      fontSize: '14px',
                                    }}
                                  />
                                </MenuItem>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Select>
              </FormControl>
            </div>
          </div>
          <div className={`${styles['tableView-headerSection-innerMain']} ${styles['tableView-headerSection-innerMain2']}`}>
            <div className={`${styles['tableView-bulletPoints-main']} ${styles['tableView-bulletPoints-main-start']}`}>
              <div className={styles['tableView-bulletPoints3']}></div>
              <div className={styles['tableView-bulletPoints-text']}>
                Nearing due date
              </div>
            </div>
            <div className={`${styles['tableView-bulletPoints-main']} ${styles['tableView-bulletPoints-main-center']}`}>
              <div className={styles['tableView-bulletPoints2']}></div>
              <div className={styles['tableView-bulletPoints-text']}>
                Crossed due date
              </div>
            </div>
            <div className={`${styles['tableView-bulletPoints-main']} ${styles['tableView-bulletPoints-main-end']}`}>
              <div className={styles['tableView-bulletPoints1']}></div>
              <div className={styles['tableView-bulletPoints-text']}>
                Unassigned
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles['tableView-data-grid-container']} ${styles['filteredRows-tableView']}}`}>
          {filteredRows && (
            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={desktopColumns}
              isFilteredRows={filteredRows}
              sortFilterColumns={sortFilterColumns}
              setTablePageNumber={setTablePageNumber}
              tablePageNumber={tablePageNumber}
              pageSize={10}
              totalPages={tablePageSize}
              totalRecords={totalRecords}
              isBackendPaginated={true}
              isEdit={false}
              onSortChange={handleSortChange}
              sortField={sortField}
              sortOrder={sortOrder}
            />
          )}
        </div>
      </div>
      {modalOpen && (
        <ManualAssignmentForm
          modalOpen={modalOpen}
          handleClose={handleCloseModal}
          onEmployeeSelect={(employee) => handleAssign(employee)}
          onAssign={handleAssign}
        />
      )}
    </div>
  );
};

export default TableView;
